function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M2.88,2.38a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5.51.51,0,0,1-.5.5A.5.5,0,0,1,2.88,2.38Zm2.5.5a.51.51,0,0,0,.5-.5.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5A.5.5,0,0,0,5.38,2.88Zm2,0a.51.51,0,0,0,.5-.5.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5A.5.5,0,0,0,7.38,2.88Zm2.37,13.5a.38.38,0,0,1-.37.37h-7A2.38,2.38,0,0,1,0,14.38v-12A2.39,2.39,0,0,1,2.38,0h16a2.38,2.38,0,0,1,2.37,2.38v8a.38.38,0,0,1-.75,0V4.75H.75v9.63A1.63,1.63,0,0,0,2.38,16h7A.38.38,0,0,1,9.75,16.38Zm-9-14V4H20V2.38A1.63,1.63,0,0,0,18.38.75h-16A1.63,1.63,0,0,0,.75,2.38ZM23.64,15.14l-7.5,7.5a.39.39,0,0,1-.16.1l-3.5,1h-.11a.36.36,0,0,1-.26-.11.39.39,0,0,1-.1-.37l1-3.5a.39.39,0,0,1,.1-.16l7.5-7.5a.37.37,0,0,1,.53,0l2.5,2.5A.37.37,0,0,1,23.64,15.14Zm-2.8,1.73-2-2-5,5,2,2Zm-7.92,6,2.24-.64-1.6-1.6Zm9.92-8-2-2-1.47,1.47,2,2Z"
})));

var SvgSignup = function SvgSignup(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.75 23.75",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signup.83d3a938.svg";
export { ForwardRef as ReactComponent };